import { application } from "./application"
import EventController from "./event_controller"
import HelloController from "./hello_controller"
import HeroSliderController from "./hero_slider_controller"
import InstagramFeedController from "./instagram_feed_controller"
import InstagramTouchController from "./instagram_touch_controller"
import MenuController from "./menu_controller"

application.register("event", EventController)
application.register("hello", HelloController)
application.register("hero-slider", HeroSliderController)
application.register("instagram-feed", InstagramFeedController)
application.register("instagram-touch", InstagramTouchController)
application.register("menu", MenuController)
